export enum paymentMethod {
  CreditCard = "78b1bd55-5223-ed11-83bf-005056890a42",
  Installment = "3ccd04d8-5323-ed11-83bf-005056890a42",
  Transfer = "8b90a739-c8ea-ec11-83be-005056890a42",
}
